/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var getTinymce = function (view) {
    var global = view;
    return global && global.tinymce ? global.tinymce : null;
};
export { getTinymce };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/TinyMCE.js
// module id = 1145
// module chunks = 0